import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useMenuSearch } from '../../hooks/useMenuSearch';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { NewMenuSearch } from '../menu-search/NewMenuSearch';
const MenuSearchContainer = ({ queryValue, brandsParentLink, categoriesParentLink, suggestionsParentLink, }) => {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState(queryValue);
    const { menuSearchItemGrouping } = useMenuSearch({
        searchTerm: searchValue,
        suggestionsParentLink,
        brandsParentLink,
        categoriesParentLink,
    });
    const setSearchTerm = (searchTerm) => {
        if (searchTerm) {
            dispatch(analyticsActions.createFetchWithoutProductsAction(searchTerm));
        }
        setSearchValue(searchTerm);
    };
    const createAdobeAnalyticsSetSearchTermAction = (searchterm) => {
        dispatch(analyticsActions.createAdobeAnalyticsSetSearchTermAction(searchterm));
    };
    return (_jsx(NewMenuSearch, { createAdobeAnalyticsSetSearchTermAction: createAdobeAnalyticsSetSearchTermAction, menuSearchItemGrouping: menuSearchItemGrouping, setSearchValue: setSearchTerm, suggestionsParentLink: suggestionsParentLink, searchValue: searchValue }));
};
export default MenuSearchContainer;
